import { money, moneyFromMajor } from '@shared/lib';
import type { DashboardDto, HomeSummaryDto } from './schemas';
import type { DashboardSummary, HomeSummary } from '../model/types';

/** Home summary DTO → domain. API sends amounts in MINOR units — cast with `money()` directly. */
export function toHomeSummary(dto: HomeSummaryDto): HomeSummary {
  const d = dto.data;
  return {
    overallReceive: money(d.overall_receive),
    thisMonthSpending: money(d.this_month_spending),
    thisMonthSettled: money(d.this_month_settled),
    activeGroups: d.active_groups,
    pendingSettlements: money(d.pending_settlements),
    spendMix: d.spend_mix.map((s) => ({
      categoryName: s.category_name,
      amount: money(s.amount),
    })),
    currency: d.currency,
  };
}

/**
 * Anti-corruption: dashboard DTO → domain summary. Unlike the rest of the API, the dashboard sends
 * amounts in MAJOR units — convert with `moneyFromMajor` (₹22 → 2200 minor) so display is correct.
 */
export function toDashboardSummary(dto: DashboardDto): DashboardSummary {
  const p = dto.data.pending_expense;
  const g = dto.data.group;
  return {
    pending: {
      unassignedCount: p?.unassigned_count ?? 0,
      incompletedCount: p?.incompleted_count ?? 0,
      recordCount: p?.record_count ?? 0,
      totalAmount: moneyFromMajor(p?.total_amount ?? 0),
    },
    group: {
      hasArchived: g?.has_archived_group ?? false,
      count: g?.group_count ?? 0,
      overallAmount: moneyFromMajor(g?.over_all_amount ?? 0),
    },
    unreadNotifications: dto.data.unread_notifications,
  };
}
